import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.88 3.2c-.5.1-.97.34-1.33.7q-.6.58-.72 1.42c-.06.32-.06 13.04 0 13.37.17 1.07.95 1.89 1.97 2.08.27.06 18.13.06 18.4 0 1.02-.2 1.8-1.02 1.97-2.08.06-.33.06-13.05 0-13.37-.17-1.07-.95-1.9-1.97-2.1-.15-.02-1.55-.03-9.22-.02zm.15 1.74c-.07.03-.17.08-.22.12-.1.08-.23.28-.27.41-.01.05-.02.72-.02 1.69v1.6h18.96V7.11l-.01-1.65-.07-.12q-.14-.27-.35-.36l-.13-.07h-8.88c-8.56-.01-8.89-.01-9.01.03m-.5 9.56v4.04l.07.13q.14.26.35.36l.13.06h17.84l.13-.06q.23-.1.35-.36l.07-.13V14.5l.01-4.04H2.52zm13.17-.12c-.28.1-.5.34-.56.64-.03.16 0 .41.08.56.07.13.25.3.4.38l.11.06h2.88l.11-.05q.28-.14.41-.41c.07-.15.08-.18.08-.38 0-.18 0-.24-.06-.35-.08-.17-.26-.35-.43-.43l-.13-.06H17.2c-1.28 0-1.4 0-1.5.04"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconCreditCard;
